import { formatGlpiDate } from "./htmlStripper";
import { CreateTicketTaskPayload } from "../types/glpi";
import { GenericTaskValue } from "../components/GenericTaskBlock";

/** Construit les payloads GLPI TicketTask à partir du bloc tâches du formulaire. */
export function buildTicketTaskPayloads(
  ticketId: number,
  task: GenericTaskValue,
  technicianId: number | null
): CreateTicketTaskPayload[] {
  const rows = (task.tasks || []).filter((t) => t.date && t.date.trim());
  if (rows.length === 0) return [];
  return rows.map((t) => {
    const [y, m, d] = t.date.split("-").map((s) => Number(s));
    const dateObj = new Date(y, (m || 1) - 1, d || 1);
    const dur = Number(t.durationMin);
    const content =
      String(t.content || t.label || task.label || "").trim() || "Tâche";
    return {
      tickets_id: ticketId,
      content,
      date: formatGlpiDate(dateObj),
      actiontime: Number.isFinite(dur) && dur > 0 ? dur * 60 : 0,
      state: 1,
      users_id_tech: technicianId ?? undefined,
    };
  });
}
